import { Input } from 'antd';

/**
 * Write-only secret input. Behavior per the spec §4.2:
 *
 *  - Renders as an empty masked input on open. Existing secret value
 *    is never echoed back (`hasSecret: bool` is the only readable
 *    signal from the GET endpoint).
 *  - Placeholder differentiates "secret already saved, leave blank to
 *    keep it" vs "you must enter a value":
 *      hasSecret === true   → "Leave blank to keep existing"
 *      hasSecret === false  → "Required"
 *  - Form-submit logic in the parent excludes the secrets object
 *    when every field in it is empty/undefined — the backend never
 *    receives an empty string for a secret field.
 */
interface Props {
  hasSecret: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export function MaskedSecretField({
  hasSecret,
  placeholder,
  value,
  onChange,
}: Props) {
  return (
    <Input.Password
      autoComplete="new-password"
      placeholder={
        placeholder ??
        (hasSecret ? 'Leave blank to keep existing' : 'Required')
      }
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
    />
  );
}
